import React, { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { Member } from '../../../models/Member'
import { Profile } from '../../../models/Profile'
import { colors } from '../../../theme/palette'
import { zIndexes } from '../../../theme/zIndex'
import { formatDate } from '../../../utils/format'
import { L } from '../../providers/Lokalise'
import { Typography } from '../../ui/Typography/Typography'

const useStyles = createUseStyles(() => ({
    control: {
        display: 'grid',
        position: 'absolute',
        alignItems: 'center',
        marginBottom: '20px',
        gridTemplateColumns: '1fr 1fr',
        paddingRight: '57px',
        paddingLeft: '20px',
        borderBottom: `2px solid ${colors.borderColor}`,
        width: 'calc(100% + 40px)',
        paddingBottom: '20px',
        top: '0',
        paddingTop: '20px',
        backgroundColor: colors.white,
        zIndex: zIndexes.drawer,
    },
    contentWrapper: {
        padding: '100px 20px 20px',
        overflow: 'auto',
        height: '100%',
        paddingBottom: '80px',
    },
}))

export type DrawerHeaderType = {
    member?: Member
    profile?: Profile
    title?: string
}

const DrawerHeader: FC<DrawerHeaderType> = ({ title }) => {
    const classes = useStyles()
    return (
        <div>
            <div className={classes.control}>
                {title ? (
                    <Typography tag="p" size="S" weight="bold">
                        {title}
                    </Typography>
                ) : null}
            </div>
        </div>
    )
}

const DrawerContent: FC = ({ children }) => {
    const classes = useStyles()
    return <div className={classes.contentWrapper}>{children}</div>
}

const DrawerHeaderMemberInfo: FC<DrawerHeaderType> = ({ member, profile }) => {
    const classes = useStyles()

    return (
        <div>
            <div className={classes.control}>
                <div>
                    <Typography tag="h4" size="XXS" color="rgba(0, 0, 0, 0.4)">
                        {L('GENERISK_RETTELSER_MEDLEM_NAVN_LABEL')}
                    </Typography>
                    {member?.fullName ? (
                        <Typography tag="p" size="XS">
                            {member.fullName}
                        </Typography>
                    ) : (
                        <Typography tag="p" size="XS">
                            {profile?.fullName}
                        </Typography>
                    )}
                </div>
                <div>
                    <Typography tag="h4" size="XXS" color=" rgba(0, 0, 0, 0.4)">
                        {L('GENERISK_RETTELSER_MEDLEM_FØDSELSDAG_LABEL')}
                    </Typography>
                    {member || profile ? (
                        <Typography tag="p" size="XS">
                            {formatDate(
                                member
                                    ? member?.birthday
                                    : new Date(profile.personalInfo.birthdate)
                            )}
                        </Typography>
                    ) : (
                        '-'
                    )}
                </div>
            </div>
        </div>
    )
}

const DrawerHeaderWorkplaceInfo: FC<DrawerHeaderType> = ({ title }) => {
    const classes = useStyles()

    return (
        <div>
            <div className={classes.control}>
                <div>
                    <Typography tag="h4" size="XXS" color="rgba(0, 0, 0, 0.4)">
                        {L('MINEMEDLEMMER_TABEL_KOLONNETITEL_ARBEJDSSTED')}
                    </Typography>
                    {title && (
                        <Typography tag="p" size="XS">
                            {title}
                        </Typography>
                    )}
                </div>
            </div>
        </div>
    )
}

export {
    DrawerHeaderMemberInfo,
    DrawerHeaderWorkplaceInfo,
    DrawerHeader,
    DrawerContent,
}
